

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _index = _interopRequireDefault(require("./utils/index"));

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function(sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

// eslint-disable-next-line no-loop-func
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function(key) { (0, _defineProperty2["default"])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function(key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

// import ENV from './utils/env';
var KEY_OF_ATTR = 'data-koolog-params'; // const SAVE_KEY = 'xdf-analysis-log_remain';

var SAVE_KEY = 'k12-analysis-log_remain';

var PageEvent = /*#__PURE__*/function() {
  function PageEvent(instance) {
    (0, _classCallCheck2["default"])(this, PageEvent);
    this.instance = instance;
    this.options = this.instance.options || {};
    this.startTime = 1 * new Date();
    this.readyTime = null;
    this.isDomReady = false;
    // eslint-disable-next-line no-restricted-globals
    this.hash = location.href;
    this.init();
  }

  (0, _createClass2["default"])(PageEvent, [{
    key: "init",
    value: function init() {
      var _this = this;

      window.addEventListener('DOMContentLoaded', function() {
        return _this.handleDomReady();
      });
      window.addEventListener('popState', function() {
        return _this.handlePopState();
      });
      window.addEventListener('pushState', function() {
        return _this.handlePushState();
      });
      window.addEventListener('replaceState', function() {
        return _this.handleReplaceState();
      });
      window.document.body.addEventListener('mousedown', function(e) {
        return _this.handleDomClick(e);
      });

      var throttleUnload = _index["default"].throttle(this.handleUnload, 300);

      window.addEventListener('beforeunload', throttleUnload.bind(this));
    }
  }, {
    key: "handleDomReady",
    value: function handleDomReady() {
      console.log('handleDomReady');
      this.isDomReady = true;
      this.readyTime = 1 * new Date(); //todo 上报上次退出页面的缓存内容
      //  

      var pageLoad = this.options.pageLoad;
      console.log('pageLoad');

      if (pageLoad === true) {
        this.checkAndSendUrl();
      }

      this.sendStorageData();
    }
  }, {
    key: "handlePopState",
    value: function handlePopState() {
      this.checkAndSendUrl();
    }
  }, {
    key: "handlePushState",
    value: function handlePushState() {
      this.checkAndSendUrl();
    }
  }, {
    key: "handleReplaceState",
    value: function handleReplaceState() {
      this.checkAndSendUrl();
    }
  }, {
    key: "handleDomClick",
    value: function handleDomClick(e) {
      // todo test e if is current dom
      var currentDom = e.target || e.srcElement;

      var detailDom = _index["default"].getElementByAttr(currentDom, KEY_OF_ATTR);

      if (detailDom === window.document.body) return;
      var params = JSON.parse(detailDom.getAttribute(KEY_OF_ATTR) || '');

      var logData = _objectSpread({
        elem: detailDom
      }, params);

      var eleName = detailDom.nodeName.toLowerCase(); // a标签增加链接属性的上报

      if (eleName === 'a') {
        var elemHref = detailDom.getAttribute('href'); // todo .trim();

        if (elemHref && !/^#/.test(elemHref) && !/^javascript:/i.test(elemHref)) {
          logData.params['targetHref'] = elemHref;
        }
      }

      this.instance.click(logData);
    }
  }, {
    key: "handleUnload",
    value: function handleUnload() {
      var now = 1 * new Date();
      // var diff = now - this.startTime;

      var prev_kuid = _index["default"].getCookie('KUID');

      var prev_logid = _index["default"].getCookie('prelogid');

      var prev_seeion_id = _index["default"].getCookie('ssoSessionID');

      var prev_url = window.location.href;
      var params = {
        event_id: 'stay_time',
        interaction_id: 'stay_time',
        interaction_type: 'push',
        start_time: this.startTime,
        dom_ready_time: this.readyTime,
        end_time: now,
        prev_kuid: prev_kuid,
        prev_logid: prev_logid,
        prev_seeion_id: prev_seeion_id,
        prev_url: prev_url
      };
      this.storageData(params);
    }
  }, {
    key: "storageData",
    value: function storageData(obj) {
      // 华为不支持localStorage，使用try，catch防止页面报错
      try {
        var paramsList = JSON.parse(localStorage.getItem(SAVE_KEY)) || [];
        paramsList.push(obj);
        console.log('unload', paramsList);
        localStorage.setItem(SAVE_KEY, JSON.stringify(paramsList));
      } catch (err) {
        console.log(err);
      }
    }
  }, {
    key: "sendStorageData",
    value: function sendStorageData() {
      var _this2 = this;

      // 华为不支持localStorage，使用try，catch防止页面报错
      try {
        var dataList = JSON.parse(localStorage.getItem(SAVE_KEY)) || [];

        _index["default"].each(dataList, function(v) {
          return _this2.instance.click(v);
        });

        localStorage.setItem(SAVE_KEY, '[]');
      } catch (err) {
        console.log(err);
      }
    }
  }, {
    key: "checkAndSendUrl",
    value: function checkAndSendUrl() {
      if (!this.isDomReady) return; // const curLocation = location.href;
      // // 防止多次上报
      // if (this.hash === curLocation) return;

      this.instance.pageView(); // this.hash = curLocation;
    }
  }]);
  return PageEvent;
}(); // export default (window => PageEvent)(ENV)


var _default = PageEvent;
exports["default"] = _default;